<div class="w-full">
  <h4 class="title text-hard-blue">Faturas</h4>

  <app-invoice-filter
    (filterChange)="filterChange($event)"
  ></app-invoice-filter>

  <div class="flex flex-wrap">
    <app-invoice-item
      *ngFor="let invoice of invoicesFiltered"
      [invoice]="invoice"
      class="w-full md:w-1/3 lg:w-1/4 p-1"
    ></app-invoice-item>
  </div>
</div>
